import { CalculatorData } from '@/services/cms/types';
import { ArrowRightLong } from '@baseline/ui';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './relatedCalcCard.module.scss';
import { cx } from 'class-variance-authority';

type CalculatorLink = NonNullable<
  NonNullable<CalculatorData['calculators'][number]['calculator_links']>[number]
>;

export default function RelatedCalcCard({ data }: { data: CalculatorLink }) {
  return (
    <a className={styles.relatedCalcCard} href={data.slug || ''}>
      <h3 className={cx(styles.header, commonStyles.sectionSubheadingH4)}>
        {data.header}
      </h3>
      <p className={cx(commonStyles.sectionSubheadingH6, styles.description)}>
        {data.description}
      </p>
      <div className={cx(styles.button, commonStyles.sectionLink)}>
        <span className={styles.buttonText}>Get started</span>{' '}
        <span className={styles.buttonIcon}>
          <ArrowRightLong />
        </span>{' '}
      </div>
    </a>
  );
}
